import React from 'react';
import {StandingsWidgetPointsDeductionsRow} from "./standings-widget.points-deductions.row";

export const StandingsWidgetPointsDeductionsRows = ({controller}) => {
  const {state} = controller;
  const {pointsDeductions} = state;

  return pointsDeductions.map(point => <StandingsWidgetPointsDeductionsRow point={point}/>);
};